import React from 'react';

const Tab = ({ children }) => <div className="py-3">{children}</div>;

export default Tab;
